import { BrandVisualKit, FontRole } from 'types'
import { FontPairing } from 'constants/fontPairings'

export const getBrandKitFontPairing = (brandKit: BrandVisualKit): FontPairing | undefined => {
  const brandKitTextStyles = brandKit.text_styles

  if (!brandKitTextStyles || brandKitTextStyles.length === 0) {
    return
  }
  const titleStyle = brandKitTextStyles.find((style) => style.font_role === FontRole.Title)
  const bodyStyle = brandKitTextStyles.find((style) => style.font_role === FontRole.Body)

  if (!titleStyle || !bodyStyle) {
    return
  }

  return [
    {
      font_role: FontRole.Title,
      style: titleStyle.style,
    },
    {
      font_role: FontRole.Body,
      style: bodyStyle.style,
    },
  ] as FontPairing
}
